import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, PropType, ref, watch } from "vue";
import { OptionItemModel } from "../../../models";
import { PopoverColorEnum, PopoverPositionEnum, TirPmIconView, TirPmPopover } from "tir-components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterProjectsParameter',
  props: {
  /**Данные опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  props.item.Width = $itemFilter.value?.offsetWidth;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$itemFilter",
    ref: $itemFilter,
    class: "filter-parameter-projects__item"
  }, [
    _createVNode(_unref(TirPmIconView), {
      isRounded: "",
      isBordered: false,
      size: 20,
      colorCode: __props.item.Color,
      imageLoadUrl: __props.item.Image
    }, {
      mainSlot: _withCtx(() => []),
      _: 1
    }, 8, ["colorCode", "imageLoadUrl"]),
    _createElementVNode("div", {
      style: _normalizeStyle({ color: __props.item.Color }),
      class: "filter-parameter-projects__name"
    }, _toDisplayString(__props.item.Name), 5)
  ], 512))
}
}

})